// extracted by mini-css-extract-plugin
module.exports = {"title":"SectionFeaturedReviews_title__3fGxb","carousel":"SectionFeaturedReviews_carousel__24_4S","step":"SectionFeaturedReviews_step__2QAQs"};